// import { BASE_URL_PROD } from '@request/baseUrl'
const BASE_URL_PROD = 'https://sensejupiter.sensetime.com'

// 文件管理
// https://sensejupiter.sensetime.com/rms-canary/#/resource-mgt
const data: { [key: string]: string } & { avatar_default: string } = {
  cert_bg: 'c1/231442403885058/cert_bg.png', //	证书
  cert_bg2: 'c1/3480631674197770241/cert_bg2.jpg', //	证书2
  config_network_step3: 'c1/231442150129666/config_network_step3.png', //	联网提示3
  config_network_step2: 'c1/231442122866690/config_network_step2.png', //	联网提示2
  config_network_step1: 'c1/231442093506562/config_network_step1.png', //	联网提示1
  qrcode_guide: 'c1/231441762156546/qrcode_guide.gif', //	扫描二维码动画
  logo: 'c1/231441644716034/logo.png', //	logo
  certification_image: 'c1/231444341653506/certification_image.png', //	证书缩略图
  certification_bg: 'c1/231444264058882/certification_bg.png', //	评测卡片背景
  coupon: 'c1/231441330143234/coupon.png', //	领取优惠券
  coupon2: 'c1/3478599590795214850/coupon2.png', //	领取优惠券2
  game3_bg: 'c1/231443785908226/game3_bg.png', //	对弈类型背景2
  game2_bg: 'c1/231450073169922/game2_bg.png', //	对弈类型背景2
  game1_bg: 'c1/231443718799362/game1_bg.png', //	对弈类型背景1
  profile: 'c1/231440866672642/profile.png', //	头像背景
  login_bg: 'c1/231440700997634/login_bg.png', //	登录背景
  invite: 'c1/231440097017858/invite.png', //	邀请图片
  avatar_default: 'c1/231440040394754/avatar_default.png', //	默认头像
  background: 'c1/231439958605826/background.png', //	页面背景
  site: 'c1/231453713825794/site.png', //加载占位符
  no_device: 'c1/231453982261250/no_device.png', //	无设备
  face_cover: 'c1/231454475091970/face_cover.png', //	人脸遮盖
}

const images = data
Object.keys(data).forEach((key) => {
  images[key] = BASE_URL_PROD + '/presigned/v1/view?objectname=' + data[key]
})

export default images
